import React, { FC } from "react";
import Modal from "react-modal";

import { CloseButton } from "../../CloseButton/CloseButton";
import ClickAwayListener from "react-click-away-listener";
import { useHandleClickAway } from "../../Hooks/useHandleClickAway";
import classNames from "classnames";

type GenericModalProps = {
  onClose: () => void;
  onSubmit?: () => void;
  isOpen: boolean;
  modalHeader: string;
  modalDescription: string;
  submitButtonLabel?: string;
};

export const GenericModal: FC<GenericModalProps> = ({
  onClose,
  onSubmit,
  isOpen,
  modalHeader,
  modalDescription,
  submitButtonLabel,
}) => {
  const { handleMouseUp, handleMouseDown, handleClickAway, areaRef } =
    useHandleClickAway(onClose);

  return (
    <Modal
      overlayClassName="react-modal__overlay"
      className={classNames(
        "react-modal__content react-modal__content--additional",
        { "react-modal__content--opened": isOpen }
      )}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div
            className="confirm-modal__inner my-2 p-2 pt-1 fs-5"
            ref={areaRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
          >
            <CloseButton onClick={onClose} withWhiteBg />
            <h4>{modalHeader}</h4>
            <div dangerouslySetInnerHTML={{ __html: modalDescription }} />
            {submitButtonLabel && (
              <div className="d-flex justify-content-center mt-2">
                <button className="btn btn-primary" onClick={onSubmit ?? onClose}>
                  {submitButtonLabel}
                </button>
              </div>
            )}
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
};
